export default __webpack_public_path__ + "static/media/beskraen-recnik.5fd24ce4.gif";